import { render } from "./RbMidScreenDialog.vue?vue&type=template&id=ee0cbb8c&scoped=true"
import script from "./RbMidScreenDialog.vue?vue&type=script&lang=js"
export * from "./RbMidScreenDialog.vue?vue&type=script&lang=js"

import "./RbMidScreenDialog.vue?vue&type=style&index=0&id=ee0cbb8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0cbb8c"]])

export default __exports__